// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"fe80a1ee","211":"5adc539f","415":"35319211","541":"dc5ace04","626":"484a103d","661":"5ad268ad","823":"553509f0","876":"c2eb9fa7","944":"9939d56c"}[chunkId] + ".chunk.js";
};